import { Card, Skeleton, Space } from "antd";
import React from "react";
import { AppLayout } from "~/components/Layout/AppLayout";
import { TopNavFallback } from "./TopNavFallback";
import "./Fallbacks.css";

/** Signup-style shell without side nav. */
export const PublicShellFallback: React.FC = () => (
  <AppLayout
    TopNavigation={<TopNavFallback />}
    SideNavigation={null}
    PageContent={
      <div className="app-fallback-public-content" aria-hidden>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Card>
            <Skeleton active paragraph={{ rows: 6 }} />
          </Card>
          <Card>
            <Skeleton active paragraph={{ rows: 4 }} />
          </Card>
        </Space>
      </div>
    }
  />
);
